/** URL-safe tab identifiers. Used in both the router and the tab component. */
export enum CustomerProfileTabKey {
    Overview = 'overview',
    Sales = 'sales',
    Service = 'service',
    Contact = 'contact',
    History = 'history',
}

export enum StockState {
    Stock = 'stock',
    Locate = 'locate',
    Order = 'order',
    InTransit = 'inTransit',
    NotAvailable = 'notAvailable',
}

export const DAYS_BEFORE_BIRTHDAY_REMINDER = 30;

/**
 * Tailwind classes for the "needs attention" accent (background, text, border).
 * Kept as a single source so the purple triad stays in step wherever the accent
 * appears. Listed as literal class strings so Tailwind's content scan generates
 * the arbitrary-value utilities.
 */
export const NEEDS_ATTENTION_ACCENT_CLASSES = {
    bg: 'bg-[#e9d8fd]',
    text: 'text-[#6b46c1]',
    border: 'border-[#6b46c1]',
} as const;
